import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MT5ConnectionState {
  server: string;
  port: number;
  login: string;
  password: string;
}

const initialState: MT5ConnectionState = {
  server: 'demo.mt5.com',
  port: 443,
  login: '',
  password: '',
};

const mt5ConnectionSlice = createSlice({
  name: 'mt5Connection',
  initialState,
  reducers: {
    setServer(state, action: PayloadAction<string>) {
      state.server = action.payload;
    },
    setPort(state, action: PayloadAction<number>) {
      state.port = action.payload;
    },
    setLogin(state, action: PayloadAction<string>) {
      state.login = action.payload;
    },
    setPassword(state, action: PayloadAction<string>) {
      state.password = action.payload;
    },
    resetConnectionForm(state) {
      state.server = initialState.server;
      state.port = initialState.port;
      state.login = initialState.login;
      state.password = initialState.password;
    },
  },
});

export const { setServer, setPort, setLogin, setPassword, resetConnectionForm } = mt5ConnectionSlice.actions;
export default mt5ConnectionSlice.reducer; 